import { Component, Prop, h } from '@stencil/core';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library';

@Component({
  tag: 'jump-icon',
  styleUrl: 'jump-icon.scss',
  shadow: true,
})
export class JumpIcon {
  /**
   * Class of the icon
   */
  @Prop() class: string;
  /**
   * Library of the icon
   */
  @Prop() library: string = 'fa';

  /**
   * Name of the icon
   **/
  @Prop() name: string = 'heart';

  /**
   * Category of the icon
   */
  @Prop() category: 'solid' | 'sharp-light' | 'sharp-regular' | 'sharp-solid' | 'sharp-thin' | 'brands' | 'regular' | 'light' | 'thin' | 'duotone' = 'solid';

  /**
   * Size of the icon
   **/
  @Prop() size: string;

  /**
   * Label for the icon
   */
  @Prop() label: string;

  /**
   * Src of the icon
   */
  @Prop() src: string;

  componentWillLoad() {
    let libraryConfig = this.lucideLibrary;
    this.size = this.size || 'inherit';
    switch (this.library) {
      case 'fa':
        libraryConfig = this.fontAwesomeLibrary;
        break;

      case 'lucide':
        libraryConfig = this.lucideLibrary;
        break;

      default:
        break;
    }

    registerIconLibrary(this.library, libraryConfig);
  }

  render() {
    if (!this.name && !this.src) {
      return `Please set the 'name' or 'src' property to display the icon`;
    }

    if (this.library === 'custom') {
      return <sl-icon library={this.library} src={this.src} size={this.size} label={this.label}></sl-icon>;
    }
    if (this.library === 'lucide') {
      return <sl-icon library={this.library} name={this.name} size={this.size} label={this.label}></sl-icon>;
    }
    if (this.library === 'fa') {
      return <sl-icon library={this.library} name={this.fontAwesomeClassGenerator(this.name, this.category)} class={this.class} size={this.size} label={this.label}></sl-icon>;
    }
  }

  fontAwesomeClassGenerator = (name: string, category: string) => {
    let fa_class = [];
    let category_class = !category ? 'category-classic' : `category-${category}`;
    category_class && fa_class.push(category_class);
    let name_class = `name-${name}`;
    name_class && fa_class.push(name_class);
    return fa_class.join(' ');
  };

  fontAwesomeLibrary = {
    resolver: name => {
      const found_classes = name.split(' ');
      const category = found_classes.find(c => c.startsWith('category-')).replace('category-', '');
      const icon_name = found_classes.find(c => c.startsWith('name-')).replace('name-', '');

      return `https://designsystem-media.jumpgroup.it/svgs/${category}/${icon_name}.svg`;
    },
    mutator: svg => svg.setAttribute('fill', 'currentColor'),
  };

  lucideLibrary = {
    resolver: name => `https://cdn.jsdelivr.net/npm/lucide-static@0.16.29/icons/${name}.svg`,
  };
}
